import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import useStyles from '../styles';
import { currencyFormatter } from 'src/utils/translator';
import { ExpandedTooltip, Icon, BackdropLoader } from '@livable/saas-react-components';
import { Typography, ToggleButtonGroup, ToggleButton, IconButton, Grid } from '@mui/material';
import BarChartPaidUnpaid from '../charts/BarChartPaidUnpaid';
import PieChartPaid from '../charts/PieChartPaid';
import PieChartUnpaid from '../charts/PieChartUnpaid';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { isValueNumber } from 'src/utils/typeValidators';
import warningImg from 'src/img/warning.svg';
export const ReimbursementReportTab = observer(_ref => {
  let totalReimbursementReportData = _ref.totalReimbursementReportData,
    chartDataByProperty = _ref.chartDataByProperty,
    chartDataByUnit = _ref.chartDataByUnit,
    chartDataByPeriod = _ref.chartDataByPeriod,
    period = _ref.period,
    periodName = _ref.periodName,
    unpaidPieChartData = _ref.unpaidPieChartData,
    paidPieChartData = _ref.paidPieChartData,
    isLoading = _ref.isLoading;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState('property'),
    _useState2 = _slicedToArray(_useState, 2),
    entityChartEnabled = _useState2[0],
    setEntityChartEnabled = _useState2[1]; // || 'unit

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h1",
    className: classes.section
  }, t('reimbursement_dashboard.reimbursement_tab_name')), /*#__PURE__*/React.createElement("div", {
    className: classes.reimbursementTabSummary
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.summaryTotal,
    color: "success"
  }, isValueNumber(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.totalPaid) ? currencyFormatter(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.totalPaid) : 'N/A'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.inlineTooltip,
    color: "light"
  }, t('reimbursement_dashboard.summary_header_recovered'), ' ', /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "info",
    title: t('reimbursement_dashboard.summary_header_recovered_tooltip'),
    placement: "bottom",
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question",
    state: "info"
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.summaryTotal,
    color: "success"
  }, isValueNumber(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.reimbursementEffectiveness) ? parseFloat(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.reimbursementEffectiveness).toFixed(2) + '%' : 'N/A'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.inlineTooltip,
    color: "light"
  }, t('reimbursement_dashboard.summary_header_reimbursement_effectiveness'), ' ', /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "info",
    title: t('reimbursement_dashboard.summary_header_reimbursement_effectiveness_tooltip'),
    placement: "bottom",
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question",
    state: "info"
  }))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.summaryTotal,
    color: "success"
  }, isValueNumber(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.lifetimePaid) ? currencyFormatter(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.lifetimePaid) : 'N/A'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.section,
    color: "light"
  }, t('reimbursement_dashboard.summary_header_lifeTime_recovered'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    className: classes.summaryTotal,
    color: "success"
  }, isValueNumber(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.recoveryEffectiveness) ? parseFloat(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.recoveryEffectiveness).toFixed(2) + '%' : 'N/A'), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    className: classes.inlineTooltip,
    color: "light"
  }, t('reimbursement_dashboard.summary_header_recovery_effectiveness'), ' ', /*#__PURE__*/React.createElement(ExpandedTooltip, {
    type: "info",
    title: t('reimbursement_dashboard.summary_header_recovery_effectiveness_tooltip'),
    placement: "bottom",
    className: classes.inlineTooltip
  }, /*#__PURE__*/React.createElement(IconButton, null, /*#__PURE__*/React.createElement(Icon, {
    type: "question",
    state: "info"
  })))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.reimbursementTabGraphHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Report per "), /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: entityChartEnabled,
    size: "small",
    exclusive: true,
    onChange: event => setEntityChartEnabled(event.target.value)
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "property"
  }, t('reimbursement_dashboard.report_per_selector_property')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "unit"
  }, t('reimbursement_dashboard.report_per_selector_unit')))), /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainer
  }, entityChartEnabled === 'unit' && (!!(chartDataByUnit !== null && chartDataByUnit !== void 0 && chartDataByUnit.length) ? /*#__PURE__*/React.createElement(BarChartPaidUnpaid, {
    id: 'units_chart',
    key: 'units_chart',
    data: chartDataByUnit
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Combined Chart Paid Unpaid Credited missing data",
    src: warningImg,
    height: '300px',
    width: '100%'
  })))), entityChartEnabled === 'property' && (!!(chartDataByProperty !== null && chartDataByProperty !== void 0 && chartDataByProperty.length) ? /*#__PURE__*/React.createElement(BarChartPaidUnpaid, {
    id: 'properties_chart',
    key: 'properties_chart',
    data: chartDataByProperty
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Combined Chart Paid Unpaid Credited missing data",
    src: warningImg,
    height: '300px',
    width: '100%'
  })))))), /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 10,
    columnSpacing: 10
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 6
  }, paidPieChartData === null || !(paidPieChartData !== null && paidPieChartData !== void 0 && paidPieChartData.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholderSingleChartV2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Chart Paid missing data",
    src: warningImg,
    height: '170px',
    width: '300px'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainerV2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: 'span'
  }, t('reimbursement_dashboard.total_paid', {
    totalPaid: "$".concat(Number(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.totalPaid).toFixed(2))
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.chartContent, " ").concat(classes.chartContentPie)
  }, /*#__PURE__*/React.createElement(PieChartPaid, {
    data: paidPieChartData
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sm: 6
  }, unpaidPieChartData === null || !(unpaidPieChartData !== null && unpaidPieChartData !== void 0 && unpaidPieChartData.length) ? /*#__PURE__*/React.createElement("div", {
    className: classes.emptyPlaceholderSingleChartV2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Chart Unpaid missing data",
    src: warningImg,
    height: '170px',
    width: '300px'
  }))) : /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainerV2
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('reimbursement_dashboard.total_unpaid', {
    totalUnpaid: "$".concat(Number(totalReimbursementReportData === null || totalReimbursementReportData === void 0 ? void 0 : totalReimbursementReportData.totalUnpaid).toFixed(2))
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.chartContent, " ").concat(classes.chartContentPie)
  }, /*#__PURE__*/React.createElement(PieChartUnpaid, {
    data: unpaidPieChartData
  }))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.reimbursementTabGraphHeader
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('reimbursement_dashboard.report_for_period', {
    period: (period === null || period === void 0 ? void 0 : period.startDateOnly) === null || (period === null || period === void 0 ? void 0 : period.endDateOnly) === null ? periodName : "".concat(moment(period === null || period === void 0 ? void 0 : period.startDateOnly).format('D MMM, YYYY'), " - ").concat(moment(period === null || period === void 0 ? void 0 : period.endDateOnly).format('D MMM, YYYY'), " (").concat(periodName, ")")
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.chartContainer
  }, !!(chartDataByPeriod !== null && chartDataByPeriod !== void 0 && chartDataByPeriod.length) ? /*#__PURE__*/React.createElement(BarChartPaidUnpaid, {
    id: 'period_chart',
    key: 'period_chart',
    data: chartDataByPeriod
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.chartHeaderV2
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "p"
  }, t('reimbursement_dashboard.no_data_charts'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Combined Chart Paid Unpaid Credited missing data",
    src: warningImg,
    height: '300px',
    width: '100%'
  }))))));
});